import { updateTraceStep } from './states';

export const services = {
  updateTraceStep,
};
